
import { GridDataService } from './grid-data.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { MessageHandlerService } from '../../utility/message-handler.service';

@Injectable()
export class AuditMemberListService extends GridDataService
{
    public auditTypes: Array<{ text: string; key: string; value: number }> = [
        { text: 'Demographics', key: 'DEMOGRAPHICS-TYPE-AUDIT', value: 0 },
        { text: 'Extensions', key: 'EXTENSIONS-TYPE-AUDIT', value: 1 }
    ];

    constructor(http: HttpClient, translate: TranslateService, messageHandlerService: MessageHandlerService)
    {
        super(http, '/audit/member/search', translate, messageHandlerService);
    }

    public getAuditTypeText(auditType: number): string
    {
        let text = auditType.toString();
        const revision = this.auditTypes.find(x => x.value === auditType);
        if (revision !== undefined)
        {
            text = revision.text;
        }
        return text;
    }
}
